import { Client } from '@/services/types'
import { ClientsGetters } from './types'

const getters: ClientsGetters = {
  getClients(state): Client[] {
    return state.clients
  },
}

export default getters
